<template>
    <div class="main-body" >
        <div class="header">账户退款</div>
        <div class="out">

          <div class="search2">

                <el-button size="mini" type="primary" @click.native="toggleModalAdd">退款</el-button>
                <div style="float:right">

                  <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px">
                    <el-option
                        v-for="item in arr_ins"
                        :key="item.institutionCode"
                        :label="item.userName"
                        :value="item.institutionCode">
                    </el-option>
                  </el-select>

                  <el-input v-model="elderlyName" placeholder="选择老人" disabled style="width: 250px">
                    <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                    <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                  </el-input>

                  <el-button size="mini" style="margin-left:5px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>

                <div style="clear: both;"></div>
            </div>


          <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>
            <el-table-column label="姓名" prop="elderlyName" width="100"></el-table-column>
            <el-table-column label="手机号" prop="elderlyDTO.phone"></el-table-column>
            <el-table-column label="身份证号" prop="elderlyDTO.idCard" width="180"></el-table-column>
            <el-table-column prop="returnBalance" label="退款金额（元）" width="150"></el-table-column>
            <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="创建时间"></el-table-column>
          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_ins="arr_ins" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>

      <Elderly ref="myElderly" v-show="showModalGetElderly"
               v-on:closeElderly="showModalGetElderly=false"
               v-on:setElderly="setElderly"></Elderly>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Add from "./AddIns";
    import Elderly from "@/views/Elderly/Comm/ElderlyInsSigning3";

    export default {
        name: "Role",
        data(){
            return{
              loading:false,

              showModalGetElderly:false,

              showModalAdd:false,


              tableData:[],
              totalItems: 0,
              pageSize:20,
              currentPage:1,


              th:0,

              elderlyCode:'',
              elderlyName:'',

              type:1,
              arr_ins:[],
              institutionCode: '',


            }
        },
        components:{
            Add,Elderly
        },
        created(){
            this.getIns();

            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{


          getIns(){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Institution/ListType",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
                type:this.type,
              }
            }).then((response) => {

              if (response.data.error === 0) {
                this.arr_ins = response.data.data.list;
                if(this.arr_ins.length>0){
                  this.institutionCode = this.arr_ins[0].institutionCode;
                  this.getList();
                }
              }else if(response.data.error === 1){
                this.$message.error(response.data.message)
              }

            })

          },


          getElderly(){
            this.showModalGetElderly = !this.showModalGetElderly;
            this.$refs.myElderly.init(this.type,this.institutionCode);
          },
          setElderly(row){
            this.elderlyCode = row.elderlyCode;
            this.elderlyName = row.name;
          },
          clearElderly(){
            this.elderlyCode = '';
            this.elderlyName = '';
          },


          formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },

            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(this.type);
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;


                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"RefundRecord/GovPageIns",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                      institutionCode:this.institutionCode,
                        elderlyCode:this.elderlyCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },


        }
    }
</script>

<style scoped>

</style>
